// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OdobrenjeAplikacija_wrapper__68OlN {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 24px;
  padding-top: 30px;
}
.OdobrenjeAplikacija_navigationRow__4L1Br,
.OdobrenjeAplikacija_tableWrapper__BKUYS,
.OdobrenjeAplikacija_pageNumber__I6QP-,
.OdobrenjeAplikacija_tableContainer__uWluz {
  display: flex;
  align-items: center;
  justify-content: center;
}
.OdobrenjeAplikacija_bottomRow__actvE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  font-size: 14px;
  line-height: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 1px 2px 0px #1018280a;
  background-color: #f8f9fb;
}
.OdobrenjeAplikacija_bottomRow__actvE,
.OdobrenjeAplikacija_navigationRow__4L1Br {
  font-family: Inter;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
}
.OdobrenjeAplikacija_navigationRow__4L1Br {
  gap: 16px;
  font-size: 16px;
  line-height: 22px;
}
.OdobrenjeAplikacija_navigationRow__4L1Br:hover {
  cursor: pointer;
  text-decoration: underline;
}
.OdobrenjeAplikacija_backArrow__7263K {
  width: 24px;
  height: 24px;
}
.OdobrenjeAplikacija_tableWrapper__BKUYS {
  width: 100%;
  margin-top: -24px;
}
.OdobrenjeAplikacija_pageNumber__I6QP- {
  width: 40px;
  height: 40px;
  padding: 0px, 16px, 0px, 16px;
  border-radius: 5px;
  background-color: #5f6d7e;
  color: white;
}
.OdobrenjeAplikacija_tableContainer__uWluz,
.OdobrenjeAplikacija_wrapper__68OlN {
  flex-direction: column;
  width: 100%;
}

.OdobrenjeAplikacija_tableContainer__uWluz {
  gap: 16px;
}
.OdobrenjeAplikacija_tablescroll__TyETP {
  width: 100%;
  overflow: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/OdobrenjeAplikacija/OdobrenjeAplikacija.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 24px;\n  padding-top: 30px;\n}\n.navigationRow,\n.tableWrapper,\n.pageNumber,\n.tableContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.bottomRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 64px;\n  font-size: 14px;\n  line-height: 20px;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: 1px solid #e6e9ec;\n  box-shadow: 0px 1px 2px 0px #1018280a;\n  background-color: #f8f9fb;\n}\n.bottomRow,\n.navigationRow {\n  font-family: Inter;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n}\n.navigationRow {\n  gap: 16px;\n  font-size: 16px;\n  line-height: 22px;\n}\n.navigationRow:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.backArrow {\n  width: 24px;\n  height: 24px;\n}\n.tableWrapper {\n  width: 100%;\n  margin-top: -24px;\n}\n.pageNumber {\n  width: 40px;\n  height: 40px;\n  padding: 0px, 16px, 0px, 16px;\n  border-radius: 5px;\n  background-color: #5f6d7e;\n  color: white;\n}\n.tableContainer,\n.wrapper {\n  flex-direction: column;\n  width: 100%;\n}\n\n.tableContainer {\n  gap: 16px;\n}\n.tablescroll {\n  width: 100%;\n  overflow: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OdobrenjeAplikacija_wrapper__68OlN`,
	"navigationRow": `OdobrenjeAplikacija_navigationRow__4L1Br`,
	"tableWrapper": `OdobrenjeAplikacija_tableWrapper__BKUYS`,
	"pageNumber": `OdobrenjeAplikacija_pageNumber__I6QP-`,
	"tableContainer": `OdobrenjeAplikacija_tableContainer__uWluz`,
	"bottomRow": `OdobrenjeAplikacija_bottomRow__actvE`,
	"backArrow": `OdobrenjeAplikacija_backArrow__7263K`,
	"tablescroll": `OdobrenjeAplikacija_tablescroll__TyETP`
};
export default ___CSS_LOADER_EXPORT___;
